// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__1LZP8","containerItemsCenter":"Skeleton_containerItemsCenter__3Y-Eu"};